import React from "react";

// libraries
import { CircularProgress, CircularProgressProps } from "@libraries/mui";

import * as Styled from "./styles";

interface CircularProgressWithPercentProps extends CircularProgressProps {
  value: number;
}

const CircularProgressWithPercent: React.FC<
  CircularProgressWithPercentProps
> = ({ value, ...rest }) => (
  <Styled.Container>
    <CircularProgress variant="determinate" value={value} {...rest} />
    <Styled.Percent>{value}%</Styled.Percent>
  </Styled.Container>
);

export default CircularProgressWithPercent;
